// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ntfEntity from './entities/ntf.json';
import ntfMenu from '../pages/ntf/menu.json';
import ntfFullForm from '../pages/ntf/forms/full.json';
import ntfContextForm from '../pages/ntf/forms/context.json';
import ntfMiniForm from '../pages/ntf/forms/mini.json';
import ntfLookupForm from '../pages/ntf/forms/lookup.json';
import ntfTableView from '../pages/ntf/views/table.json';
import ntfStagesView from '../pages/ntf/views/stages.json';
import ntfCardsView from '../pages/ntf/views/cards.json';
import ntfInlineView from '../pages/ntf/views/inline.json';
import ntfBacklogView from '../pages/ntf/views/backlog.json';
import ntfSplitView from '../pages/ntf/views/split.json';
import ntfCalendarView from '../pages/ntf/views/calendar.json';
import ntfDashboardView from '../pages/ntf/views/dashboard.json';

/** Тип запису «Правило сповіщення» зі сторінками пакета: меню, форми та подання з pages/ntf/. */
export const ntfDefinition: IRecordTypeDefinition = {
  ...ntfEntity,
  views: assembleViewSet({
      table: ntfTableView,
      stages: ntfStagesView,
      cards: ntfCardsView,
      inline: ntfInlineView,
      backlog: ntfBacklogView,
      split: ntfSplitView,
      calendar: ntfCalendarView,
      dashboard: ntfDashboardView,
  }),
  form: ntfFullForm,
  forms: { full: ntfFullForm, context: ntfContextForm, mini: ntfMiniForm, lookup: ntfLookupForm },
  menu: ntfMenu,
} as IRecordTypeDefinition;
